// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7cc69b1a] .distribution-detail > .dot {\n  width: 32px;\n  height: 32px;\n}\n[data-v-7cc69b1a] .distribution-detail > .dot > em {\n  margin: 0% !important;\n}\n.distribution-card[data-v-7cc69b1a] {\n  position: relative;\n}\n.close-icon[data-v-7cc69b1a] {\n  position: absolute;\n  top: 0.5rem;\n  right: 0rem;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
